import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import styles from './SubmissionPanelHeader.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getOrganizationUrl = organizationId =>
  `${API_BASE_URL}/organizations/${organizationId}/assets/branding.png`;

const SubmissionPanelHeader = ({ project, organization }) =>
  <div className={styles.header}>
    <div
      className={styles.logoLeft}
      style={{
        backgroundImage: `url(${project.logoUri})`,
      }}
    />
    <div
      className={styles.logoRight}
      style={{
        backgroundImage: `url(${getOrganizationUrl(
          organization.organizationId,
        )})`,
      }}
    />
  </div>;

const mapState = state =>
  R.pipe(R.path(['application']), R.pick(['project', 'organization']));

export default connect(mapState)(SubmissionPanelHeader);



// WEBPACK FOOTER //
// ./src/submission/components/SubmissionPanelHeader.js